import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ApproachesToLearning from "./routes/ApproachesToLearning";
import GlobalContexts from "./routes/GlobalContexts";
import KeyConcepts from "./routes/KeyConcepts";
import TimelineInsights from "./routes/TimelineInsights";
import CustomDatasetInsights from "./routes/CustomDatasetInsights";

export default store => ({
  path: "horizontalOverview/:gradeId",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "planning-insights" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    GlobalContexts(store),
    KeyConcepts(store),
    ApproachesToLearning(store),
    TimelineInsights(store),
    CustomDatasetInsights(store),
  ],
});
